import {charcoal} from '../../sass/v2/_exports.sass';

export const CalendarAddIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M27.106 20.25v4.122h4.123v2.749h-4.123v4.122h-2.749v-4.122h-4.123v-2.749h4.123v-4.123ZM10.62 3.748h8.246V1h2.748v2.749h5.497a1.375 1.375 0 0 1 1.374 1.374v13.055h-2.748v-3.435H3.749v10.994h14.086v2.748H2.375A1.374 1.374 0 0 1 1 27.111V5.123a1.375 1.375 0 0 1 1.374-1.374h5.497V1h2.749Zm-6.871 8.245h21.988V6.497h-4.123v2.749h-2.748V6.497H10.62v2.749H7.87V6.497H3.75Z"
        style={{strokeWidth: 1.37427}}
      />{' '}
    </svg>
  );
};
